import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import ChevronRightOutlined from "@mui/icons-material/ChevronRightOutlined";
import MovieCreationRounded from "@mui/icons-material/MovieCreationRounded";
import { useParams } from "../../../../../../shell/hooks/useParams";
import { Filetype } from "../../../../../../shell/store/media-revamp";
type VideoFilterRow = {
  onClose: () => void;
};
export const VideoFilterRow: FC<VideoFilterRow> = ({
  onClose
}) => {
  const {
    t
  } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [params, setParams] = useParams();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    onClose();
  };
  const handleChange = (filetype: Filetype) => {
    setParams(filetype, "filetype");
    handleClose();
    onClose();
  };
  return <>
      {/*@ts-expect-error*/}
      <MenuItem onClick={handleClick} data-sentry-element="MenuItem" data-sentry-source-file="VideoFilterRow.tsx">
        <ListItemIcon data-sentry-element="ListItemIcon" data-sentry-source-file="VideoFilterRow.tsx">
          <MovieCreationRounded fontSize="small" data-sentry-element="MovieCreationRounded" data-sentry-source-file="VideoFilterRow.tsx" />
        </ListItemIcon>
        <ListItemText data-sentry-element="ListItemText" data-sentry-source-file="VideoFilterRow.tsx">{t("media.filetypeFilterVideos")}</ListItemText>
        <ListItemIcon style={{
        minWidth: "0px"
      }} data-sentry-element="ListItemIcon" data-sentry-source-file="VideoFilterRow.tsx">
          <ChevronRightOutlined fontSize="small" data-sentry-element="ChevronRightOutlined" data-sentry-source-file="VideoFilterRow.tsx" />
        </ListItemIcon>
      </MenuItem>
      <Menu open={open} onClose={handleClose} anchorEl={anchorEl} anchorOrigin={{
      vertical: "top",
      horizontal: "right"
    }} data-sentry-element="Menu" data-sentry-source-file="VideoFilterRow.tsx">
        <MenuItem onClick={() => handleChange("Video")} data-sentry-element="MenuItem" data-sentry-source-file="VideoFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="VideoFilterRow.tsx">
            {t("media.videoFilterAllTypes")}
          </Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("MPEG")} data-sentry-element="MenuItem" data-sentry-source-file="VideoFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="VideoFilterRow.tsx">MPEG</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("MP4")} data-sentry-element="MenuItem" data-sentry-source-file="VideoFilterRow.tsx">
          {/* eslint-disable-next-line i18next/no-literal-string -- file format token */}
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="VideoFilterRow.tsx">MP4</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("MOV")} data-sentry-element="MenuItem" data-sentry-source-file="VideoFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="VideoFilterRow.tsx">MOV</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("WMV")} data-sentry-element="MenuItem" data-sentry-source-file="VideoFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="VideoFilterRow.tsx">WMV</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("AVI")} data-sentry-element="MenuItem" data-sentry-source-file="VideoFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="VideoFilterRow.tsx">AVI</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("FLV")} data-sentry-element="MenuItem" data-sentry-source-file="VideoFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="VideoFilterRow.tsx">FLV</Typography>
        </MenuItem>
      </Menu>
    </>;
};